// eslint-disable-next-line no-unused-vars
import React, { Component } from 'react'
import qs from 'qs'
import Layout from '../Layout'
import ConfirmationBox from './ConfirmationBox'
import { OnboardingService } from '../../services/onboardingService'
import isEnv from '../../isEnv'

const onboardingCookieName = 'participantInfo'

class ConfirmationAccountPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isLoading: false
    }
    document.cookie = `${onboardingCookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`
  }

  async componentDidMount() {
    this.setState({ isLoading: true })
    const { user_name } = qs.parse(this.props.location.search.substring(1))
    if (isEnv(process.env.RAZZLE_ONBOARDING_ENABLED)) {
      const cpfEncoded = Buffer.from(user_name).toString('base64')
      try {
        const result = await OnboardingService.SearchCPF(cpfEncoded)
        if (result.name && result.name.length > 0) {
          result.username = user_name
          this.setOnboardingCookie(onboardingCookieName, result)
        }
      } catch (err) {
        console.error(err)
      } finally {
        this.setState({ isLoading: false })
      }
    }
  }

  setOnboardingCookie = (name, value) => {
    var date = new Date()
    date.setTime(date.getTime() + 60 * 1000)
    var expires = ';expires=' + date.toGMTString()
    const cookieValue = Buffer.from(JSON.stringify(value)).toString('base64')
    document.cookie = `${name}=${cookieValue}${expires};path=/`
  }

  render() {
    return (
      <Layout>
        <ConfirmationBox {...this.state} />
      </Layout>
    )
  }
}

export default ConfirmationAccountPage
